export type InvoiceType =
  | 'debris'
  | 'non_debris_contractor'
  | 'force_account_labor'
  | 'force_account_equipment';

export type EvidenceType = 'auto' | 'file' | 'manual';
export type ChecklistItemStatus = 'pending' | 'satisfied' | 'waived';
export type ClaimStatus = 'draft' | 'submitted' | 'approved' | 'paid';

export interface ChecklistTemplateItem {
  id: string;           // UUID, stable across edits
  label: string;
  description: string;
  required: boolean;
  evidenceType: EvidenceType;
  autoSource?: string;  // human-readable description of what the system checks (for 'auto' items)
  order: number;
}

export interface ChecklistTemplate {
  invoiceType: InvoiceType;
  items: ChecklistTemplateItem[];
}

// Persisted human-actioned item (from debrisChecklistItems table)
export interface ChecklistItem {
  id: number;           // record_id
  invoiceId: string;    // invoice or claim record_id as string
  invoiceType: InvoiceType;
  templateItemId: string;
  label: string;
  evidenceType: EvidenceType;
  status: ChecklistItemStatus;
  fileDocId?: string;
  fileName?: string;
  waiverReason?: string;
  checkedBy?: string;
  checkedAt?: string;
  notes?: string;
}

// Computed at runtime for auto items
export interface AutoCheckResult {
  templateItemId: string;
  label: string;
  status: 'pass' | 'fail' | 'unavailable';
  detail: string;       // e.g. "3 tickets linked, CY variance 0.8%"
  link?: string;        // optional navigation target
}

export interface FAClaim {
  id: number;
  claimNumber: string;
  claimType: 'labor' | 'equipment';
  incidentId: string;
  billingPeriodStart: string;
  billingPeriodEnd: string;
  status: ClaimStatus;
  totalCost: number;
  entryIds: number[];
  notes: string;
}

export const INVOICE_TYPE_LABELS: Record<InvoiceType, string> = {
  debris: 'Debris Removal',
  non_debris_contractor: 'Non-Debris Contractor',
  force_account_labor: 'Force Account Labor',
  force_account_equipment: 'Force Account Equipment',
};
